import { Record } from 'immutable';
import CountryRecord from '~/data/CountryRecord';
import BusinessPartner from '~/data/BusinessPartner';

const keys: Fields = {
  customerNumber: '',
  businessPartner: new BusinessPartner(),
  companyName: '',
  country: new CountryRecord(),
  salesCompanyContactNumber: '',
  timeZone: '',
  contactNumber: '',
};

export interface Fields {
  customerNumber: string;
  businessPartner: BusinessPartner;
  companyName: string;
  country: CountryRecord;
  salesCompanyContactNumber: string;
  timeZone: string;
  contactNumber: string;
}

export default class FleetAccountRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);
    return this.merge(values);
  }

  merge(values) {
    return super.merge(this.__get(values));
  }

  __get(values) {
    if (!values) {
      return {};
    }

    const newValues: Partial<Fields> = Object.keys(keys).reduce((acc, key) => {
      if (values[key]) {
        acc[key] = values[key];
      }
      return acc;
    }, {});

    if (values.businessPartner) {
      newValues.businessPartner = new BusinessPartner(values.businessPartner);
    }

    if (values.country) {
      newValues.country = new CountryRecord(values.country);
    }
    return newValues;
  }
}
